import ButterToast from 'butter-toast';
import CompleteToastContent from "./CompleteToastContent";

export function showFailedToast ({
    fileName = fileName ?? "",
    large = false,
    scheme = "SCHEME_RED",
    message = "",
    title,
    showLink = false,
    history,
    companyId,
  }) {

    return ButterToast.raise({
      content: (
        <CompleteToastContent
          fileName={fileName}
          large={large}
          scheme={scheme}
          message={message}
          title={title}
          showLink={showLink}
          history={history}
          companyId={companyId}
        />
      ),
      sticky: true,
    });
  };